export default __webpack_public_path__ + "static/media/doc-image.c028175e.svg";